<template>
    <div style="overflow-x:hidden">
        <!--  弃用 -->
        <BannerStatic :ban="banner"></BannerStatic>
        <NewsDetail></NewsDetail>
    </div>
</template>

<script>
import BannerStatic from '@/components/header/bannerStatic.vue'
import NewsDetail from '@/components/news/newsDetail.vue'

export default {
    components:{
        BannerStatic,
        NewsDetail
    },
    data(){
        return{
            banner:require('@/assets/bannerNews.jpg')
        }
    }
}
</script>